import { createContext, useContext } from 'react';

export const FromPathnameContext = createContext('');

export const useFromPathname = () => useContext(FromPathnameContext);
